import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

import { BASE_URL, SUGGESTION_GET_REPORT, SUGGESTION_GET_TOPIC, SUGGESTION_SHEET, M_POST } from '@/utils/api';

@Module({ name: 'suggest' })
export default class Suggest extends VuexModule {
  suggestMember: any = [];

  @Mutation
  mutateSuggest(suggest: any) {
    this.suggestMember = suggest;
  }

  @Action({ commit: 'mutateSuggest', rawError: true })
  async FetchSuggest(payload: any) {
    try {
      const { criteria, __successToast } = payload || {};

      const { data } = await axios({
        url: BASE_URL + SUGGESTION_GET_REPORT,
        data: criteria,
        method: M_POST,
        __successToast
      } as ExtAxiosConfig);

      assertOk(data, 'Fetch suggestion report failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch suggestion report failed');
    }
  }

  @Action({ rawError: true })
  async FetchTopic() {
    try {
      const { data } = await axios({
        url: BASE_URL + SUGGESTION_GET_TOPIC,
        method: M_POST,
        data: {}
      });

      assertOk(data, 'Fetch suggestion topic failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch suggestion topic failed');
    }
  }

  @Action({ rawError: true })
  async DownloadSheet(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + SUGGESTION_SHEET,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Download suggestion sheet failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Download suggestion sheet failed');
    }
  }
}
